module.exports = __webpack_public_path__ + "6f21d9542ffceb8200194f081fb3e2d6.pdf";